import { get, post } from '@/utils/axios';

// 赔付列表 查询
export function getCompensation(params) {
  return post('/bs/supplierCompensation/compensationQuery', params);
}

// 确认是否为使用新履约的地区
export function ensureRegion(params) {
  return get('/bs/supplierCompensation/ensureRegion', params);
}

// 赔付-详情
export function getCompensationDetail(params) {
  return get('/bs/supplierCompensation/compensationDetail', params);
}

// 确认是否具有订单履约权限
export function ensurePermission(params) {
  return get('/bs/supplierCompensation/ensurePermission', params);
}

// 赔付原因 枚举 列表
export function getCompensationReasons(params) {
  return get('/bs/supplierCompensation/enum/reason', params);
}

// 赔付状态 枚举 列表
export function getCompensationStatus(params) {
  return get('/bs/supplierCompensation/enum/status', params);
}

// 责任方 枚举 列表
export function getResponsibleDepartments(params) {
  return get('/bs/supplierCompensation/enum/departments', params);
}

// 具体原因 枚举 列表 通过责任方获取
export function getReasonsByDepartment(params) {
  return get('/bs/supplierCompensation/enum/reasonsByDepartment', params);
}

// 具体原因 枚举 列表 通过责任方获取
export function isRegionFullOpen(params) {
  return get('/bs/supplierCompensation/isFullOpen', params);
}
